import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import useWindowDimensions from "../../../WindowSize";
import ChooseCar from "../../../Header/ChooseCar";
import { connect } from "react-redux";
import {
  fetchCartAddons,
  setCartAddedPackages,
  setCartJobItems,
  setCartJourney,
  setCartProducts,
  setCartStage,
  setShowMobileIstand,
} from "../../../../redux/actions/cartAction";
import toast from "react-hot-toast";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import { FaAngleDown, FaAngleUp, FaCheckCircle, FaWhmcs } from "react-icons/fa";
import { workshopPurchase } from "../../../../lib/config";
import { isMobile } from "react-device-detect";
import { gtmServiceContract } from "../../../../lib/google-tag-manager";
import { setLayer } from "../../../../redux/actions/globalAction";
import { getCategory } from "../../../../redux/actions/apiActions";
import EmptyCartModal from "../EmptyCartModal";
import CommonModel from "components/common/CommonModel";
import { useEffect } from "react";
import { HiMiniArrowTopRightOnSquare } from "react-icons/hi2";
import ChooseCarMobile from "components/common/ChooseCarMobile";
import { MdInfoOutline } from "react-icons/md";
import {
  gtm_ecommerce_add_to_cart,
  gtm_ecommerce_remove_from_cart,
} from "lib/GA4_tag";

let header = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const PackageListItem = ({
  showDescription,
  setShowDescription,
  setTypeOne,
  show,
  handleShow,
  variant,
  getCarBrandModal,
  getModel,
  getWorkshopFilterMap,
  setCartStage,
  setCartProducts,
  cart,
  globalData,
  apiData,
  setCartJobItems,
  fetchCartAddons,
  setCartAddedPackages,
  setCartJourney,
  setShowMobileIstand,
  setLayer,
  getCategory,
  id,
  showMobileChooseCar,
  setShowMobileChooseCar,
}) => {
  const { height, width } = useWindowDimensions();
  const [hide, setHide] = useState(true);
  const [hideId, setHideId] = useState(null);
  const [selected, setSelected] = useState(null);
  const [viewServices, setViewServices] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);
  const [expandServices, setExpandServices] = useState(null);
  const [showtabby, setShowtabby] = useState(false);
  const [tabbyModel, setTabbyModel] = useState(false);
  const [showCarPopUp, setShowCarPopUp] = useState(false);

  let { products, jobItems, addedPackages, workshop } = cart;

  useEffect(() => {
    const SHOW_TABBY_PAY =
      globalData.carData != null ? variant.Cost : variant.MinCost > 450;
    setShowtabby(
      SHOW_TABBY_PAY && process.env.NEXT_PUBLIC_ACTIVE_TABBY_PAYMENT
    );
  }, [variant]);

  const addToCart = () => {
    localStorage.removeItem("tyreProduct");
    const filterCategory = apiData.categories?.filter((item) => item.ID == 15);
    const event = {
      currency: "AED",
      value: variant.Cost,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          // discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };
    gtm_ecommerce_add_to_cart(event);
    setLayer(true);
    gtmServiceContract(variant.Name);
    setCartJourney(workshopPurchase);

    if (isMobile) {
      setShowMobileIstand(true);
    }

    const result = addedPackages.filter((res, index) => res.Id == variant.Id);
    if (result.length == 0) {
      setCartAddedPackages([...addedPackages, variant]);
      setCartStage(2);
    } else {
      // alert('already added')
      toast.dismiss();
      toast.error("Already Added!");
    }
  };

  const removeFromCart = () => {
    const filterCategory = apiData.categories?.filter((item) => item.ID == 15);

    const event = {
      currency: "AED",
      value: variant.Cost,
      items: [
        {
          item_id: variant.Id,
          item_name: variant.Name,
          // discount: variant.DiscountedCost || 0,
          item_category: filterCategory[0].Name,
          item_list_id: filterCategory[0].ID,
          item_list_name: filterCategory[0].Name,
          price: variant.Cost,
          quantity: 1,
        },
      ],
    };

    gtm_ecommerce_remove_from_cart(event);
    const result = addedPackages.filter((res, index) => res.Id != variant.Id);
    if (result.length == 0) {
      setShowEmpty(true);
      return;
    }
    setCartAddedPackages(result);
  };

  let checkAdded =
    addedPackages.filter((packageItem) => packageItem.Id == variant.Id)
      .length === 1;

  const isSelected =
    addedPackages.filter((packageItem) => packageItem.Id == variant.Id)
      .length === 1;

  return (
    <>
      <Container className="py-3">
        <ChooseCarMobile show={showCarPopUp} setShow={setShowCarPopUp} />
        <div className="product-tabby-text">
          <CommonModel
            istabby={true}
            show={tabbyModel}
            onHide={() => {
              setTabbyModel(false);
            }}
          >
            <iframe
              id="tabby-installment-iframe"
              src="https://checkout.tabby.ai/promos/product-page/installments/en/"
              height="546px"
              width="100%"
              style={{ borderWidth: 0 }}
            ></iframe>
          </CommonModel>
        </div>
        <EmptyCartModal
          id={id}
          show={showEmpty}
          onHide={() => {
            setShowEmpty(false);
            sessionStorage.removeItem("get-fitting-at-home");
          }}
          title="Are you sure?"
          message="By removing last item, your cart will be reset to empty cart."
          getCategory={getCategory}
        />

        <div class="listing-container-pl border-pl-list sc-custom-margin">
          <div class="row">
            {isMobile ? (
              <div class="col-md-12">
                <div class="product-section-pl-header">
                  <div class="product-section-pl-hd-flex">
                    <div class="product-section-pl-hd-flex">
                      <h3>
                        {variant.Name}
                        {"    "}
                      </h3>
                      <label>
                      <span class="free-lab ml-2">Service Contract</span>
                    </label>

                      {/* <h3 className="ml-1">SERVICE CONTRACT</h3> */}
                    </div>
                  </div>
                  <div className="mnf-yrs">{variant.Description}</div>
                  <label
                    style={
                      !variant.IsRecommended || !variant.LableText
                        ? { display: "none" }
                        : {}
                    }
                  >
                    {variant?.IsRecommended ? (
                      <span className="rec-lab">
                        Recommended <i className="fa-regular fa-thumbs-up" />
                      </span>
                    ) : null}
                    {variant?.LableText ? (
                      <span className="free-lab">{variant?.LableText}</span>
                    ) : null}
                  </label>
                </div>
              </div>
            ) : (
              <div class="col-md-12">
                <div class="product-section-pl-header">
                  <div class="product-section-pl-hd-flex">
                    <div class="product-section-pl-hd-flex">
                      <h3>
                        {variant.Name}
                        {"    "}
                      </h3>
                      <label>
                        <span class="free-lab ml-2">Service Contract</span>
                      </label>
                    </div>
                    <label
                      style={
                        !variant.IsRecommended || !variant.LableText
                          ? { display: "none" }
                          : {}
                      }
                    >
                      {variant?.IsRecommended ? (
                        <span className="rec-lab">
                          Recommended <i className="fa-regular fa-thumbs-up" />
                        </span>
                      ) : null}
                      {variant?.LableText ? (
                        <span className="free-lab">{variant?.LableText}</span>
                      ) : null}
                    </label>
                  </div>
                  <div className="mnf-yrs">{variant.Description}</div>
                </div>
              </div>
            )}

            <div class="pl-fl-box">
              <div class="pl-fl-img">
                <div class="position-relative-pr">
                  <img
                    class="product-image-container-pl"
                    src={variant.ImgUrl || "/assets/images/workshop.jpg"}
                  />
                </div>
              </div>

              <div class="pl-fl-ft-sec">
                <div class="pl-fl-lst">
                  {!isMobile ? (
                    <p className="mb-1">
                      <span class="cst-badge-sc">
                        Valid For: {variant.ValidKm?.toLocaleString()} km or{" "}
                        {variant.ValidDays} Days
                      </span>
                    </p>
                  ) : null}
                  <div className="mnf-yrs">
                    <em>This contract covers the following services:</em>
                  </div>
                  <Row className="mt-2">
                    {showDescription != variant.Id
                      ? variant.InfoLines != null &&
                        variant.InfoLines.slice(0, isMobile ? 3 : 4).map(
                          (infoLine, index) => (
                            <>
                              <Col lg={6} className="product-content d-flex">
                                <img
                                  className="product-content-image mr-1"
                                  src="/assets/images/tick.webp"
                                />
                                <ReadMoreReact
                                  text={infoLine.Description}
                                  min={10}
                                  readMoreText={
                                    <a className="text-primary">Read More</a>
                                  }
                                />
                                {/* {infoLine.Description} */}
                              </Col>
                            </>
                          )
                        )
                      : variant.InfoLines != null &&
                        variant.InfoLines.map((infoLine, index) => (
                          <>
                            <Col lg={6} className="product-content d-flex">
                              <img
                                className="product-content-image mr-1"
                                src="/assets/images/tick.png"
                              />
                              <ReadMoreReact
                                text={infoLine.Description}
                                min={10}
                                readMoreText={
                                  <a className="text-primary">Read More</a>
                                }
                              />
                            </Col>
                          </>
                        ))}
                    {variant.InfoLines.length > (isMobile ? 3 : 4) && (
                      <Col
                        lg={6}
                        onClick={() => {
                          setShowDescription(
                            showDescription == variant.Id ? false : variant.Id
                          );
                        }}
                        role="button"
                        className="product-content"
                      >
                        <label style={{ fontSize: "12px" }}>
                          {showDescription == variant.Id
                            ? "- View Less"
                            : "+ View More"}
                        </label>
                      </Col>
                    )}
                  </Row>
                  {process.env.NEXT_PUBLIC_ACTIVATE_VIEW_INSPECTION_BUTTON &&
                  variant?.SampleDocuments &&
                  variant.SampleDocuments?.length ? (
                    <div className={"custom-pdf-ob mt-1"}>
                      <a
                        href={
                          variant?.SampleDocuments[0]?.SourceUrl ||
                          "about:blank"
                        }
                        target="_blank"
                      >
                        {variant?.SampleDocuments[0]?.Name}{" "}
                        <HiMiniArrowTopRightOnSquare size={14} />
                      </a>
                    </div>
                  ) : null}
                </div>

                <div class="price-pl-blck dsk-view">
                  <div class="price-pl-lf">
                    <label class="price-tag-pl d-flex align-items-center">
                      <span className="pr-1">Best Price</span>
                      <strong>
                        {"AED " +
                          (globalData.carData != null
                            ? variant.Cost
                            : variant.MinCost)}
                      </strong>
                    </label>
                  </div>
                  <div class="price-pl-rght">
                    {globalData.carData != null ? (
                      <>
                        {checkAdded ? (
                          <Button
                            onClick={removeFromCart}
                            className="workshop-button-one remove"
                            // disabled={
                            //   excludedVariantIds.includes(variant.Id) ||
                            //   checkAdded
                            // }
                          >
                            {/* {checkAdded ? "Added" : "Add to cart"} */}
                            Remove
                          </Button>
                        ) : (
                          <Button
                            onClick={addToCart}
                            className="workshop-button-one shine-animation-new"
                            style={{ fontSize: "13px", lineHeight: "13px" }}
                            //   disabled={
                            //     excludedVariantIds.includes(variant.Id) ||
                            //     checkAdded
                            //   }
                          >
                            Add to cart
                          </Button>
                        )}
                      </>
                    ) : (
                      <ChooseCar
                        globalData={globalData}
                        style={"workshop-button-one"}
                        textTrue={true}
                        apiData={apiData}
                        getModel={getModel}
                        getCarBrandModal={getCarBrandModal}
                        text="Choose Car to View Price"
                        showMobileBtn={isMobile ? true : false}
                      />
                    )}
                  </div>
                </div>
                {showtabby ? (
                  <div className="tabby-bar-pr-list dsk-tabby sr-contract-tabby mt-2">
                    <img src="/assets/images/tabby.webp" />
                    <p>
                      Split in 4 interest-free payments of{" "}
                      <strong>AED 212.75</strong> / month{" "}
                      <span onClick={() => setTabbyModel(true)}>
                        <MdInfoOutline size={16} />
                      </span>
                    </p>
                  </div>
                ) : null}
              </div>
            </div>
            {isMobile ? (
              <div class="pl-feture-first-space">
                <p className="mb-1">
                  <span class="cst-badge-sc">
                    Valid For: {variant.ValidKm?.toLocaleString()} km or{" "}
                    {variant.ValidDays} Day
                  </span>
                </p>
                <p
                  className="mb-1 pl-feture-first-space2"
                  style={{ marginLeft: "30px" }}
                >
                  <span
                    class="cst-badge-sc"
                    onClick={() => setViewServices(true)}
                    style={{ paddingLeft: "10px" }}
                  >
                    {/* <FaWhmcs className="mr-1" /> */}
                    View All Service Details
                  </span>
                </p>
              </div>
            ) : null}
          </div>
          <div className="mobile-pl-bar-action mobile-pl-sr-cont-mg">
            <div class="oft-lbs none hide">
              <label
                class="pl-offer-label"
                onClick={() => setViewServices(true)}
                style={{ paddingLeft: "10px" }}
              >
                <FaWhmcs className="mr-1" />
                View All Service Details
              </label>
            </div>

            <div
              className="pl-feture-first"
              style={{ borderTop: "1px solid #ccc", paddingTop: "5px" }}
            >
              <div className="price-pl-lf">
                <label className="price-tag-pl">
                  <span>Best Price</span>
                  <strong>
                    {"AED " +
                      (globalData.carData != null
                        ? variant.Cost
                        : variant.MinCost)}
                  </strong>
                </label>
              </div>
              <div className="oft-lbs">
                {variant.Offer && (
                  <label
                    className="pl-offer-label"
                    title={"Offer Available"}
                    onClick={() => setChangeOfferModalShow(true)}
                  >
                    <img src="/assets/products/party-icon.wepb" />3 Offer
                    Available
                  </label>
                )}
              </div>
            </div>
            {showtabby ? (
              <div className="tabby-bar-pr-list mob-tabby mt-2">
                <img src="/assets/images/tabby.webp" />
                <p>
                  Split in 4 interest-free payments of{" "}
                  <strong>AED 212.75</strong> / month
                  <span onClick={() => setTabbyModel(true)}>
                    <MdInfoOutline size={16} />
                  </span>
                </p>
              </div>
            ) : (
              ""
            )}
            <div
              className="mobile-bottom-sr-select align-package"
              style={{
                justifyContent: globalData.carData != null ? "right" : "left",
              }}
            >
              {globalData.carData != null ? (
                checkAdded ? (
                  <Button
                    className="srv-act-action bg-yellow"
                    // disabled={
                    //   excludedVariantIds.includes(variant.Id) ||
                    //   checkAdded
                    // }
                  >
                    {/* {checkAdded ? "Added" : "Add to cart"} */}
                    Remove
                  </Button>
                ) : (
                  <Button
                    onClick={addToCart}
                    className="srv-act-action shine-animation-new"
                    style={{ fontSize: "13px", lineHeight: "13px" }}
                    //   disabled={
                    //     excludedVariantIds.includes(variant.Id) ||
                    //     checkAdded
                    //   }
                  >
                    Add to cart
                  </Button>
                )
              ) : (
                <span
                  style={{
                    fontSize: "11px",
                    border: "0px",
                    background: "#0451be",
                    color: "white",
                  }}
                  className={"ob-button mx-2 mt-3 tour-1 ob-button-custom"}
                  onClick={() => {
                    setShowCarPopUp(true);
                  }}
                >
                  Choose Your Car
                </span>
              )}
            </div>
          </div>
        </div>

        {/* <Row>
          <Col lg={3} xs={4} className="product-center px-sm-2 px-0">
            <div className="position-relative">
              <img
                className="product-image-container"
                src={variant.ImgUrl || "/assets/images/workshop.jpg"}
              />
            </div>
          </Col>
          <Col lg={9} xs={8} className="product-details">
           
            <h3 className="product-service package-title package-title-mobile d-flex align-items-center">
              {variant.Name}{" "}
              <span class="badge badge-secondary ml-2">Service Contract</span>
            </h3>
            <div className="hide-in-mobile">
              <p className="m-0 text-dark">{variant.Description}</p>
              <p className="m-0">
                <span class="badge badge-success">
                  Valid For: {variant.ValidKm?.toLocaleString()} km or{" "}
                  {variant.ValidDays} Days
                </span>
              </p>
              <p className="m-0" style={{ fontSize: 14 }}>
                <em>This contract covers the following services:</em>
              </p>
              <Row>
                {showDescription != variant.Id &&
                  variant.InfoLines != null &&
                  variant.InfoLines.map((infoLine, index) => (
                    <>
                      <Col lg={6} className="product-content">
                        <img
                          className="product-content-image mr-1"
                          src="/assets/images/tick.png"
                        />
                        {infoLine.Description}
                      </Col>
                    </>
                  ))}
               
              </Row>
            </div>

           
          </Col>
        </Row>

        <div className="for-mobile">
          <p className="m-0 mt-2 text-dark">{variant.Description}</p>
          <p className="m-0">
            <span class="badge badge-success">
              Valid For: {variant.ValidKm} km, {variant.ValidDays} Days
            </span>
          </p>
          <p className="m-0" style={{ fontSize: 14 }}>
            <em>This contract covers the following services:</em>
          </p>
          <Row>
            {showDescription != variant.Id &&
              variant.InfoLines != null &&
              variant.InfoLines.map((infoLine, index) => (
                <>
                  <Col lg={6} className="product-content">
                    <img
                      className="product-content-image mr-1"
                      src="/assets/images/tick.png"
                    />
                    {infoLine.Description}
                  </Col>
                </>
              ))}
            
          </Row>
        </div>

        <Row
          className={
            !isMobile
              ? "justify-content-between align-items-center price-area"
              : "justify-content-between align-items-center price-area m-0 p-0"
          }
        >
          <>
            <div className="d-flex align-items-center pl-sm-4 pl-0 mb-sm-0 mb-4">
              <Button
                onClick={() => setViewServices(true)}
                className="package-service-btn"
              >
                <FaWhmcs className="mr-1" />
                View All Service Details
              </Button>
            </div>
            <div
              className={
                !isMobile
                  ? "workshop-row d-flex justify-content-end align-items-center w-100 w-sm-auto"
                  : "workshop-row d-flex align-items-center w-100 w-sm-auto"
              }
            >
              <div className="mr-3 font-weight-bold d-flex align-items-center selected-product">
                <p className="text-dark m-0">
                  {"AED " +
                    (globalData.carData != null
                      ? variant.Cost
                      : variant.MinCost)}
                </p>
              </div>
              {globalData.carData != null ? (
                <>
                  {checkAdded ? (
                    <Button
                      onClick={removeFromCart}
                      className="workshop-button-one remove"
                    
                    >
                      Remove
                    </Button>
                  ) : (
                    <Button
                      onClick={addToCart}
                      className="workshop-button-one"
                    
                    >
                      Add to cart
                    </Button>
                  )}
                </>
              ) : !isMobile ? (
                <ChooseCar
                  globalData={globalData}
                  style={"workshop-button-one"}
                  textTrue={false}
                  apiData={apiData}
                  getModel={getModel}
                  getCarBrandModal={getCarBrandModal}
                />
              ) : (
                <div>
                  <span
                    style={{
                      border: "0px",
                      background: "#0451be",
                      color: "white",
                    }}
                    className={"ob-button mx-3 mt-3 tour-1 ob-button-custom"}
                    onClick={() => {
                      setShowMobileChooseCar(true);
                    }}
                  >
                    Choose Your Car
                  </span>
                </div>
              )}
              {showtabby && isMobile ? (
                <p>
                  <div>
                    <img
                      style={{ marginTop: "2px" }}
                      src="/assets/tabby-pay.png"
                      className="payment-method-image tabby mr-1"
                      height={18}
                      width={40}
                      alt="Tabby"
                    />
                    <span className="custom-font-size-payment">
                      <label>
                        {" "}
                        Split in 4 interest-free payments of
                        <span className="product-tabby-amount custom-font-size-payment custom-bold-span">
                          AED&nbsp;{" "}
                          {parseFloat(
                            globalData.carData != null
                              ? variant.Cost
                              : variant.MinCost
                          ).toFixed(0) / 4}
                        </span>{" "}
                        / month
                        <a
                          onClick={() => {
                            setTabbyModel(true);
                          }}
                        >
                          <span className="tabby-tooltip custom-tooltip">
                            <span className="custom-tooltip-icon custom-span-checkout">
                              <i className="icon-question" />
                            </span>
                          </span>
                        </a>
                      </label>
                    </span>
                  </div>
                </p>
              ) : null}
            </div>
          </>
          
        </Row> */}
      </Container>
      <Modal show={viewServices} onHide={() => setViewServices(false)}>
        <Modal.Header className="bg-grey-official" closeButton>
          <Modal.Title
            className="d-flex align-items-center"
            style={{ flexWrap: "wrap", gap: "5px" }}
          >
            {variant.Name}{" "}
            <span class="badge badge-secondary">Service Contract</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <p className="mb-1">
              View Details of the services covered in this contract
            </p>
            {variant.VariantItems.map((service, index) => (
              <>
                <Row
                  className={
                    "justify-content-between align-items-center py-2 " +
                    (expandServices == index ? "" : "border-bottom")
                  }
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={service.ImgUrl}
                      width="50px"
                      height="50px"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                    <h5 className="m-0 ml-2 package-service-head">
                      {service.Name}
                    </h5>
                  </div>
                  {expandServices == index ? (
                    <FaAngleUp
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: 8,
                      }}
                      onClick={() => setExpandServices(null)}
                    />
                  ) : (
                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: 8,
                      }}
                      onClick={() => setExpandServices(index)}
                    />
                  )}
                </Row>
                {expandServices === index && (
                  <Row className="border-bottom">
                    {service.InfoLines.map((item, index) => (
                      <Col xs={6} className="pl-0">
                        <p
                          className="m-0 text-dark"
                          style={{
                            fontSize: 14,
                          }}
                        >
                          <FaCheckCircle /> {item.Description}
                        </p>
                      </Col>
                    ))}
                  </Row>
                )}
              </>
            ))}
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartStage: (stage) => {
      dispatch(setCartStage(stage));
    },
    setLayer: (stage) => {
      dispatch(setLayer(stage));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    setCartProducts: (products) => {
      dispatch(setCartProducts(products));
    },
    setCartJobItems: (products) => {
      dispatch(setCartJobItems(products));
    },
    fetchCartAddons: (workshopId, variantId, carModeId) => {
      dispatch(fetchCartAddons(workshopId, variantId, carModeId));
    },
    setCartAddedPackages: (packages) => {
      dispatch(setCartAddedPackages(packages));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    getCategory: () => {
      dispatch(getCategory());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageListItem);
